import { httpClient } from '../lib/http-client';

/**
 * Service para estatísticas e informações do sistema
 */
export class SistemaService {
  static async getSistemaEstatisticas(): Promise<{ success: boolean; data: any }> {
    return httpClient.get<{ success: boolean; data: any }>('/api/sistema/estatisticas');
  }

  static async getAnexosPorPeriodo(params: {
    periodo?: string;
    tipo?: string;
    limite?: number;
    offset?: number;
  } = {}): Promise<{
    success: boolean;
    data: any[];
    total: number;
    limite: number;
    offset: number;
    total_paginas: number;
    pagina_atual: number;
    periodo: string;
    tipo: string;
  }> {
    return httpClient.get<{
      success: boolean;
      data: any[];
      total: number;
      limite: number;
      offset: number;
      total_paginas: number;
      pagina_atual: number;
      periodo: string;
      tipo: string;
    }>('/api/sistema/anexos-por-periodo', { params });
  }

  static async getPastasAnexos(params: { limite?: number; offset?: number } = {}): Promise<{
    success: boolean;
    data: any[];
    total: number;
    limite: number;
    offset: number;
    total_paginas: number;
    pagina_atual: number;
  }> {
    return httpClient.get<{
      success: boolean;
      data: any[];
      total: number;
      limite: number;
      offset: number;
      total_paginas: number;
      pagina_atual: number;
    }>('/api/sistema/pastas-anexos', { params });
  }
}

